import {createBrowserRouter} from "react-router-dom";
import ErrorPage from "./App/Routes/ErrorPage";
import InformationsPage from "./App/Routes/InformationsPage";
import NewPage from "./App/Routes/NewPage";
import StorePage from "./App/Routes/StorePage";
import MaintenancePage from './App/Routes/MaintenancePage'
import Logout from "./StarterKit/Route/Logout";
import LoginPage from "./App/Routes/LoginPage";
import LostPage from "./App/Routes/LostPage";
import CAPage from "./App/Routes/CAPage";
import MargePage  from "./App/Routes/MargePage";
import ObjectifsPage from "./App/Routes/CADetPage";
import AchatsPage from "./App/Routes/AchatsPage";
import PaxPage from "./App/Routes/PaxPage";
import CADetPage from "./App/Routes/CADetPage";

var root = document.getElementById('root');

window.addEventListener('ref',function () {
  load()
})

const router = createBrowserRouter([
 
  { 
    path: "/login", 
    element: <LoginPage />,
    errorElement: <ErrorPage /> 
  },
  {
    path: "/logout",
    element: <Logout />,
    errorElement: <ErrorPage />
  },
  { 
    path: "/infos", 
    element: <InformationsPage />, 
    errorElement: <ErrorPage /> 
  },
  { 
    path: "/",
    element: <CAPage />, 
    errorElement: <ErrorPage />
  },
  { 
    path: "/ca",
    element: <CAPage />,
    errorElement: <ErrorPage />
  },
  {
    path: "/marge",
    element: <MargePage />,
    errorElement: <ErrorPage />
  },
  {
    path: "/ca_detail",
    element: <CADetPage />,
    errorElement: <ErrorPage />
  },
  { 
    path: "/achats",
    element: <AchatsPage />,
    errorElement: <ErrorPage />
  },
  { 
    path: "/pax",
    element: <PaxPage />,
    errorElement: <ErrorPage />
  },
  {
    path: "/new",
    element: <NewPage />,
    errorElement: <ErrorPage />
  },
  {
    path: "/product/:gtin/:serial/service/maintenance",
    element: <MaintenancePage />,
    errorElement: <ErrorPage />
  },
  {
    path: "/product/:gtin/:serial/service/lost",
    element: <LostPage />,
    errorElement: <ErrorPage />
  }

]);



function load() {
  var header = document.getElementById('header')
  var header__product = document.querySelector('.header__product')


  // if (header) {
  //   var offfset = header.offsetHeight;
  //   if (header.classList.contains('titleHead')) {
  //     root.style.paddingTop = offfset + 'px'
  //
  //   } else {
  //     root.style.paddingTop = 0 + 'px'
  //   }
  // }

  var footer = document.getElementById('footer')
  if (footer) {
    root.classList.add('footerHeight')
    root.style.paddingBottom = footer.offsetHeight + 'px'
  } else {
    root.classList.remove('footerHeight')
    root.style.paddingBottom = 0 + 'px'
  }

  if (footer) {
    var elementfooter = document.querySelectorAll('.footerItemContainer div')

    for (let i = 0; i < elementfooter.length ; i++) {
      elementfooter[i].addEventListener('click',function () {
        
      })
    }
  }
}
export function removeHashFromUrl() {
  if (window.location.href.includes('#')) {
    const url = window.location.href.replace('/#', '/');
    window.location.href = url;
  }
  return null;
}

window.addEventListener('load',function () {
  setTimeout(() => {
    load();
    detectBacklink();
    fulllink();
    addclassroot();

  }, "200")
})


window.addEventListener('click',function () {
  var footer = document.getElementById('footer')
  var header__product = document.querySelector('.header__product')
  setTimeout(() => {
    if (!header__product) {
      load();
    }
    detectBacklink();
    fulllink();
    addclassroot();
  }, "300")
  if (header__product) {
    setTimeout(() => {
        load();
    }, "50")
  }
})

function detectBacklink() {
  var productTitleBack = document.getElementById('productTitleBack')
  var Wallet = document.querySelector('.walletPage')
  if (productTitleBack) {
    productTitleBack.addEventListener('click',function () {
      localStorage['backclick'] = 1;
    })
  } else if (Wallet) {
  } else {
    localStorage.removeItem('backclick')
  }
}


function fulllink() {
  setTimeout(() => {
    var fullLink = document.querySelectorAll('a')
    for (let i = 0; i < fullLink.length; i++) {
      fullLink[i].addEventListener('click',function () {
        var root = document.getElementById('root')
        root.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      })
    }
  }, "200")
}

function addclassroot() {
  var header__product = document.querySelector('.header__product')
  if (header__product) {
    var addclassRoot = document.getElementById('root')
    addclassRoot.classList.add('productHeader')
  } else {
    var addclassRoot = document.getElementById('root')
    addclassRoot.classList.remove('productHeader')
  }
}













export default router;
